import api from './api';

export const selectEcgById = async (id) => {
  const response = await api.get(`/ecg/${id}`);
  return response.data;
};
